import ManageTreatments from "./manage/ManageTreatments";

export default function AestheticManage() {
  return <ManageTreatments />;
}
